import {useMutationFactory} from '@possible/cassandra/src/utils'

import {BankAddDebitPaymentMethodDocument} from 'src/products/MCU/AccountManagementV2/PaymentMethods/DebitCard/mutations/BankAddDebitPaymentMethod/BankAddDebitPaymentMethod.gqls'

// eslint-disable-next-line react-hooks/rules-of-hooks
export const useBankAddDebitPaymentMethod = useMutationFactory(BankAddDebitPaymentMethodDocument)
